module.exports = __webpack_public_path__ + "img/logo_dark_BDO.ef46aef5.png";